import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { EmailDetails, EmailResponse } from '../models/email.model';
import { SimpleResponse } from '../models/genericResponse.model';
import { delayedRetryHttp } from '../shared/delayedRetry';
import { UtilityService } from './shared/utility.service';


@Injectable()
export class EmailService {
  private baseUrl: string;
  private api: string = "api/Email";

  constructor(private httpClient: HttpClient, @Inject('BASE_URL') _baseUrl: string) {
    this.baseUrl = _baseUrl + this.api;
  }

  private handleErrors(errorResponse: HttpErrorResponse) {
    if (errorResponse.error instanceof ErrorEvent) {
      console.error('Email Service Client Side Error: ', errorResponse.error.message);
    } else {
      throw errorResponse;
    }
  }

  async sndEmailAsync(encryptedUser: string, emailDetails: EmailDetails, contactId?: number, emailTemplateType?: string, contractSessionId?: number): Promise<EmailResponse | void> {
    const a = await this.httpClient.post<EmailResponse>(`${this.baseUrl}/SendEmail/${contactId}/${emailTemplateType}/${contractSessionId}`, emailDetails, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Basic ' + encryptedUser
      })
    })//.pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, emailDetails, "", encryptedUser, "EmailService", "sndEmailAsync"); });
      .toPromise().catch(err => { this.handleErrors(err) });

    return a;
  }
}
